import { useEffect, useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { BaseCustomModal, sampleMode } from '../../../shared';
import { GeneralInfoFormTab } from './GeneralInfoFormTab';
import { SampleMassiveTab } from './SampleMassiveTab';
import { GradientDecorationLine } from '../../../shared';
import classnames from 'classnames';
import moment from "moment";
import { useModalFormHook } from '../hooks/useModalFormHook';
import { DEFAULT_PAGE_SIZE } from '../../../constants/tables';

export const CreateSamplesModal = ({
    setShowModal,
    showModal,
    modalHeader,
    isUpdate,
    isClone,
    rowInfo,
    kinds,
    unitMeasures,
    locations,
    regions,
    labsegments,
    coordinations,
    labareas,
    customers,
    users,
    modalClose,
    labRequest = null,
    mode = sampleMode.sample,
    senderUser = null,
    id,
    laboratoryType,
    pageSize = DEFAULT_PAGE_SIZE,
}) => {
    const {
        formikFormData,
        setInheritedIsUpdate,
        setInheritedIsClone,
        setInheritedRowInfo,
        setInheritedShowModal,
        sampleCount,
        setSampleCount,
        samples,
        setSamples,
        validateAndProceedToNextTab,
        setIsButtonDisabled,
        isButtonDisabled,
        setInitialSampleDate,
    } = useModalFormHook({ mode, labRequest, senderUser, id, modalClose, laboratoryType, pageSize });

    const initialSampleDate = formikFormData.values.dateAt;

    const resetFormAndCloseModal = () => {
        formikFormData.resetForm();
        setSampleCount(1);
        setSamples([{ description: "", date: moment().format("YYYY-MM-DD") }]);
        setActiveTab("1");
        setShowModal(false);
        setIsButtonDisabled(false);
        modalClose();
    };

    const [activeTab, setActiveTab] = useState('1');
    const [modalWidth, setModalWidth] = useState(
        window.innerWidth < 992 ? "90%" : "66%"
    );

    useEffect(() => {
        const handleResize = () => {
            setModalWidth(window.innerWidth < 992 ? "90%" : "66%");
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        setInheritedIsUpdate(isUpdate);
        setInheritedRowInfo(rowInfo);
        setInheritedShowModal(showModal);
        setInheritedIsClone(isClone);
    }, [isUpdate, rowInfo, showModal, isClone, setInheritedIsUpdate, setInheritedRowInfo, setInheritedShowModal, setInheritedIsClone]);

    const children = (
        <>
            <GradientDecorationLine />
            <Nav tabs className="d-flex nav-tabs-custom justify-content-start">
                <NavItem className='px-5'>
                    <NavLink
                        className={classnames({ active: activeTab === '1' })}
                        onClick={() => setActiveTab('1')}
                    >
                        1- Información General
                    </NavLink>
                </NavItem>
                <NavItem className='px-5'>
                    <NavLink
                        className={classnames({ active: activeTab === '2' })}
                        onClick={() => validateAndProceedToNextTab(setActiveTab)}
                    >
                        2- Descripción y Fecha de Muestreo
                    </NavLink>
                </NavItem>
            </Nav>

            <TabContent activeTab={activeTab} className='p-3'>
                <TabPane tabId="1">
                    <GeneralInfoFormTab
                        labareas={labareas}
                        labsegments={labsegments}
                        coordinations={coordinations}
                        customers={customers}
                        users={users}
                        unitMeasures={unitMeasures}
                        kinds={kinds}
                        locations={locations}
                        regions={regions}
                        sampleCount={sampleCount}
                        setSampleCount={setSampleCount}
                        setActiveTab={setActiveTab}
                        formikFormData={formikFormData}
                        resetFormAndCloseModal={resetFormAndCloseModal}
                        validateAndProceedToNextTab={validateAndProceedToNextTab}
                        isButtonDisabled={isButtonDisabled}
                        isUpdate={isUpdate}
                        mode={mode}
                        rowInfo={rowInfo}
                        setInitialSampleDate={setInitialSampleDate}
                    />
                </TabPane>
                <TabPane tabId="2">
                    <SampleMassiveTab
                        samples={samples}
                        setSamples={setSamples}
                        setShowModal={setShowModal}
                        setActiveTab={setActiveTab}
                        formikFormData={formikFormData}
                        resetFormAndCloseModal={resetFormAndCloseModal}
                        isUpdate={isUpdate}
                        isClone={isClone}
                        rowInfo={rowInfo}
                        sampleCount={sampleCount}
                        initialSampleDate={initialSampleDate}
                        initialKind={formikFormData.values.kind}
                        initialRegion={formikFormData.values.region}
                        initialUnitMeasure={formikFormData.values.unitMeasure}
                        initialQuantity={formikFormData.values.quantity}
                        unitMeasures={unitMeasures}
                        kinds={kinds}
                        regions={regions}
                    />
                </TabPane>
            </TabContent>
        </>
    );

    return (
        <>
            <BaseCustomModal
                title={<span style={{ fontSize: '20px', color: '#1D4370', fontWeight: 'bold' }}>{modalHeader}</span>}
                isModalOpen={showModal}
                handleOk={resetFormAndCloseModal}
                handleCancel={resetFormAndCloseModal}
                width={modalWidth}
                footer={null}
                children={children}
            />
        </>
    );
};